import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { Layout } from './components/Layout';
import { RequireAuth } from './components/RequireAuth';
import { SplashScreen } from './components/SplashScreen';
import { AboutPage } from './pages/AboutPage';
import { DiceRegistrationPage } from './pages/DiceRegistrationPage';
import { ErrorLogPage } from './pages/ErrorLogPage';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PracticePage } from './pages/PracticePage';
import { RollPage } from './pages/RollPage';
import { SettingsPage } from './pages/SettingsPage';

/**
 * Redirect from legacy /sessions/join?code=X to /?code=X
 */
function JoinRedirect() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  return <Navigate to={code ? `/?code=${encodeURIComponent(code)}` : '/'} replace />;
}

export default function App() {
  const [splashDone, setSplashDone] = useState(
    () => typeof window !== 'undefined' && !!sessionStorage.getItem('splashShown')
  );
  const isHydrating = useAuthStore((state) => state.isHydrating);

  return (
    <>
      {!splashDone && (
        <SplashScreen onDismiss={() => setSplashDone(true)} isReady={!isHydrating} />
      )}
      <BrowserRouter>
        <Routes>
          {/* Login page — outside Layout (no nav) */}
          <Route path="/login" element={<LoginPage />} />

          {/* All other routes require authentication */}
          <Route element={<RequireAuth />}>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              {/* Legacy session routes redirect to home */}
              <Route path="sessions/start" element={<Navigate to="/" replace />} />
              <Route path="sessions/join" element={<JoinRedirect />} />
              {/* Legacy endpoint routes redirect to home */}
              <Route path="endpoints/new" element={<Navigate to="/" replace />} />
              <Route path="endpoints/:id/edit" element={<Navigate to="/" replace />} />
              <Route path="roll" element={<RollPage />} />
              <Route path="practice" element={<PracticePage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="register" element={<DiceRegistrationPage />} />
              <Route path="error-log" element={<ErrorLogPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}
